import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  HOME: {
    path: `${baseRoutes.userBaseRoutes}`,
  },
};

export default accessRoute;
